import React from 'react';
import { bool, shape, string } from 'prop-types';

const ArrowBackToTop = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9L4.0575 10.0575L8.25 5.8725V15H9.75V5.8725L13.935 10.065L15 9L9 3L3 9Z" fill="currentColor" />
  </svg>
);

ArrowBackToTop.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default ArrowBackToTop;
